import apiHandler from "./apiHandler";

import { parseDuration, defaultPagination } from "@/utils/helpers";

const apiSchedules = {
  details: (id) => {
    return new Promise((resolve, reject) => {
      // defaultPagination(pagination);
      apiHandler
        .get("/schedule/" + id)
        .then((response) => {
          if (response.data.airframes !== undefined) {
            response.data.airframes.forEach((item, i) => {
              if (item == "small") response.data.airframes[i] = "pax_small";
              if (item == "medium") response.data.airframes[i] = "pax_medium";
              if (item == "large") response.data.airframes[i] = "pax_large";
              if (item == "ga") response.data.airframes[i] = "pax_ga";
              if (item == "bizjet") response.data.airframes[i] = "pax_bizjet";
            });
          }

          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  airport: {
    fetch: (airport, pagination, needle) => {
      return new Promise((resolve, reject) => {
        defaultPagination(pagination);
        apiHandler
          .post(`/airport/${airport.icao}/schedules`, {
            skip: (pagination.page - 1) * pagination.rowsPerPage,
            count: pagination.rowsPerPage,
            needle: needle,
            sort: pagination.sortBy !== null ? pagination.sortBy : "",
            order: pagination.descending ? -1 : 1,
          })
          .then((response) => {
            // pagination.rowsNumber = response.data.totalResults;
            resolve({
              results: response.data.results,
              pagination,
            });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  airline: {
    fetch: (airline, pagination, needle) => {
      return new Promise((resolve, reject) => {
        defaultPagination(pagination);
        apiHandler
          .post("/airline/" + airline._id + "/schedules", {
            skip: (pagination.page - 1) * pagination.rowsPerPage,
            count: pagination.rowsPerPage,
            needle: needle,
            sort: pagination.sortBy !== null ? pagination.sortBy : "",
            order: pagination.descending ? -1 : 1,
          })
          .then((response) => {
            pagination.rowsNumber = response.data.totalResults;

            response.data.results.forEach((schedule) => {
              if (schedule.airframes !== undefined) {
                schedule.airframes.forEach((item, i) => {
                  if (item == "small") schedule.airframes[i] = "pax_small";
                  if (item == "medium") schedule.airframes[i] = "pax_medium";
                  if (item == "large") schedule.airframes[i] = "pax_large";
                  if (item == "ga") schedule.airframes[i] = "pax_ga";
                  if (item == "bizjet") schedule.airframes[i] = "pax_bizjet";
                });
                schedule.airframes = [...new Set(schedule.airframes)];
              }
            });

            resolve({
              results: response.data.results,
              pagination,
            });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    available: (airline, type = "pax") => {
      return new Promise((resolve, reject) => {
        // defaultPagination(pagination);
        apiHandler
          .get(`/airline/${airline._id}/available/schedules/${type}`)
          .then((response) => {
            resolve(response.data.results);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    export: (airline, onProgress, onDone, filters) => {
      apiHandler.fetchExport(
        `/airline/${airline._id}/schedules/export`,
        onProgress,
        onDone,
        filters,
      );
    },
    import: (
      airline,
      schedules,
      onProgress,
      onDone,
      clearSchedules,
      clearAirports,
    ) => {
      let url = `/airline/${airline._id}/schedules/import`;

      const queryParams = {
        clear_schedules: clearSchedules,
        clear_airports: clearAirports,
      };

      const searchParams = new URLSearchParams(queryParams);

      if (searchParams.toString() != "") url += "?" + searchParams.toString();

      apiHandler.sendImport(url, schedules, onProgress, onDone);
    },
  },
  add: (airline, schedule) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .post(`/airline/${airline._id}/schedule`, {
          schedule: {
            id: schedule._id,
            type: schedule.type,
            flightNumber: schedule.flightNumber,
            depIcao: schedule.dep.icao,
            arrIcao: schedule.arr.icao,
            duration: parseDuration(schedule.duration),
            weekDays: schedule.weekDays,
            airframes: schedule.airframes,
          },
        })
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  update: (airline, schedule) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .patch(`/airline/${airline._id}/schedule/${schedule._id}`, {
          schedule: {
            type: schedule.type,
            flightNumber: schedule.flightNumber,
            depIcao: schedule.dep.icao,
            arrIcao: schedule.arr.icao,
            duration:
              typeof schedule.duration === "number"
                ? schedule.duration
                : parseDuration(schedule.duration),
            weekDays: schedule.weekDays,
            airframes: schedule.airframes,
            active: schedule.active,
          },
        })
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  delete: (airline, schedule) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .delete(`/airline/${airline._id}/schedule/${schedule._id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export default apiSchedules;
